export var ThemeMode;
(function (ThemeMode) {
    ThemeMode[ThemeMode["Light"] = 0] = "Light";
    ThemeMode[ThemeMode["Dark"] = 1] = "Dark";
})(ThemeMode || (ThemeMode = {}));
